module.exports = __webpack_public_path__ + "static/media/vegetable.5d49513e.svg";